import React from 'react';
import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import { getPublishedPosts } from '../content/blog';
import { SMS_DEEP_LINK, SMS_DISPLAY_NUMBER } from '../components/landing/constants';

const BlogPage: React.FC = () => {
  const posts = getPublishedPosts();

  return (
    <div className="min-h-screen bg-aspen-warm-ivory dark:bg-aspen-night-sage">
      <PageSEO
        title="Ask Aspen Blog — Productivity, Accountability, and AI Coaching Tips"
        description="Productivity tips, accountability strategies, and AI coaching insights from Ask Aspen. Learn how to manage tasks, beat procrastination, and stay on track."
        canonicalPath="/blog"
        breadcrumbName="Blog"
      />
      <SiteHeader />

      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-aspen-deep-eucalyptus dark:text-aspen-pearl sm:text-5xl">
            The Ask Aspen Blog
          </h1>
          <p className="mt-4 text-xl text-aspen-sage-teal dark:text-aspen-gentle-teal max-w-2xl mx-auto">
            Insights on productivity, accountability, and how AI can help you get things done.
          </p>
        </div>

        <div className="space-y-8">
          {posts.map((post) => (
            <article
              key={post.slug}
              className="bg-white dark:bg-aspen-twilight-teal rounded-xl shadow-md p-8 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="text-sm font-medium text-aspen-vibrant-blue bg-aspen-vibrant-blue/10 px-3 py-1 rounded-full">
                  {post.category}
                </span>
                <span className="text-sm text-aspen-sage-teal dark:text-aspen-gentle-teal">
                  {post.date}
                </span>
                <span className="text-sm text-aspen-sage-teal dark:text-aspen-gentle-teal">
                  {post.readTime}
                </span>
              </div>
              <h2 className="text-2xl font-semibold text-aspen-deep-eucalyptus dark:text-aspen-pearl mb-3">
                <Link to={`/blog/${post.slug}`} className="hover:text-aspen-vibrant-blue transition-colors">
                  {post.title}
                </Link>
              </h2>
              <p className="text-base text-aspen-sage-teal dark:text-aspen-gentle-teal mb-4">
                {post.description}
              </p>
              <Link
                to={`/blog/${post.slug}`}
                className="text-aspen-vibrant-blue hover:underline font-medium"
              >
                Read more →
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-aspen-sage-teal dark:text-aspen-gentle-teal mb-4">
            Want thoughtful support in your messages? Text Ask Aspen for conversation, reminders, and consent based check-ins.
          </p>
          <a href={SMS_DEEP_LINK} className="text-aspen-vibrant-blue hover:underline font-medium">Text {SMS_DISPLAY_NUMBER}</a>
          <span className="mx-3 text-aspen-sage-teal/50">|</span>
          <Link to="/how-it-works" className="text-aspen-vibrant-blue hover:underline font-medium">Learn how it works</Link>
          <span className="mx-3 text-aspen-sage-teal/50">|</span>
          <Link to="/features" className="text-aspen-vibrant-blue hover:underline font-medium">See all features</Link>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
};

export default BlogPage;
